import { PropsWithChildren, ReactElement } from 'react';
import {
  StepperContextProvider,
  StepperProviderProps,
  useStepperContext,
} from '@/components/shared/Stepper/StepperContext.tsx';
import CustomTabPanel from '@/components/shared/CustomTabPanel/CustomTabPanel.tsx';
import LoaderWrapper from '@/components/ui/LoaderWrapper/LoaderWrapper.tsx';

type StepperProps<T extends readonly string[]> = StepperProviderProps<T>;

const Wrapper = <T extends readonly string[]>(props: PropsWithChildren<StepperProps<T>>) => {
  return <StepperContextProvider {...props}>{props.children}</StepperContextProvider>;
};

type StepProps<T extends readonly string[]> = {
  step: StepperProps<T>['steps'][number];
  children: ReactElement<unknown>;
};
const Step = <T extends readonly string[]>({ children, step }: StepProps<T>) => {
  const { step: currentStep, isLoadingStep } = useStepperContext<T, any>();

  return step === currentStep ? (
    <CustomTabPanel step={step} currentStep={currentStep} className="max-w-full">
      {isLoadingStep ? <LoaderWrapper isLoading={isLoadingStep} /> : children}
    </CustomTabPanel>
  ) : null;
};

const Stepper = {
  Wrapper,
  Step,
};

export default Stepper;
